/* eslint-disable quotes */
/* eslint-disable no-undef */
$(document).ready(function() {
  // slick
  $(".location-content-gallery-slider").slick({
    lazyLoad: "progressive",
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    dots: false,
    infinite: false,
    // autoplaySpeed: 5000,
    prevArrow: $(".location-content-gallery .slider-btn-prev"),
    nextArrow: $(".location-content-gallery .slider-btn-next")
  });
  $(".block-gallery-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $(".block-gallery .slider-btn-prev"),
    nextArrow: $(".block-gallery .slider-btn-next")
  });
  $(".wp-google-reviews").slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    prevArrow: $(".review-slider-container .slider-btn-prev"),
    nextArrow: $(".review-slider-container .slider-btn-next"),
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: 'unslick'
      // instead of a settings object
    ]
  });
  $("body.home .feature-cards").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: $(".feature-cards-container .slider-btn-prev"),
    nextArrow: $(".feature-cards-container .slider-btn-next"),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: 'unslick'
      // instead of a settings object
    ]
  });
  $(".region-slider-gallery").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    prevArrow: $(".region-slider .slider-btn-prev"),
    nextArrow: $(".region-slider .slider-btn-next"),
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1160,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      ,
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  // slick carousel Controlled by events of Location and Suburb videos (of vimeo)
  // When the video is on play will stop the autoplay and reactivate it when the video is on pause
  if ($(".location-content-gallery-slider").length) {
    var iframesContainers = $(".block-gallery__video").find('iframe');

    if (iframesContainers && iframesContainers.length > 0) {
      for (let index = 0; index < iframesContainers.length; index++) {
        const videoIframe = iframesContainers[index],
         player = new Vimeo.Player(videoIframe);

        player.on("play", function() {
          $(".location-content-gallery-slider")
            .slick("slickSetOption", "autoplay", false)
            .slick("slickPause");
        });

        player.on("pause", function() {
          $(".location-content-gallery-slider")
            .slick("slickSetOption", "autoplay", true)
            .slick("slickPlay");
        });
      }
    }
  }

  // if the arrow of a carousel is pressed, will pause all the videos on the carousel Note: this event will work in everything but in the steps
  $(".slider-btn.slick-arrow").on("click", function(e) {
    e.preventDefault();
    var parent = $(this).parent(),
      videoIframe = parent.find(".block-gallery__video").find('iframe');

    for (let index = 0; index < videoIframe.length; index++) {
      const player = new Vimeo.Player(videoIframe[index]);

      player
        .pause()
        .then(function() {
          // The video is paused
        })
        .catch(function(error) {
          console.log("Video Error", error);
          switch (error.name) {
            case "PasswordError":
              // The video is password-protected
              break;

            case "PrivacyError":
              // The video is private
              break;

            default:
              // Some other error occurred
              break;
          }
        });
    };
  });
});
